<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <v-col cols="12" sm="12" md="12" class="pb-0">
      <v-alert dense border="left" class="text-center" color="#0277bd" dark>
        <h3>INFORMACIÓN DEL DOCENTE</h3>
      </v-alert>
    </v-col>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="mt-2 pt-0">
        <v-select dense label="Docente" :style="{ width: '100%' }" :items="listDocente" v-model="id_personal"
          item-text="apellido_nombre" item-value="id" :return-object="true" :rowHeight="20"
          :rules="validateFields ? validationRules.validateCampo : []" @change="getDocente(id_personal)">
        </v-select>
      </v-col>
      <v-col>
        <ButtonComp icon-but="fas fa-sync-alt" class-color="green" tooltipText="Limpiar los filtros"
          @click="cleanFiltro()" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3" class="pt-0">
        <AutocompleteComp textLabel="Tipo de docente" v-model="tipo_docente" :items="tipoDocente" item-value="id"
          item-text="desc_tipo_docente" :rules="validateFields ? validationRules.validateCampo : []" />
      </v-col>

      <v-col cols="12" sm="6" md="3" class="py-0">
        <v-combobox clearable v-model="cantidad_horaacademica" label="Cantidad de horas semanales" :items="cantidadHoras"
          :rules="validateFields ? validationRules.validateCampo : []"></v-combobox>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-0">
        <AutocompleteComp v-model="id_nivel" :items="listNivel" attach chips textLabel="Nivel" multiple
          item-text="desc_nivel" item-value="id" hide-details @change="GetAreasNivel"
          :rules="validationRules.validateCampo">
          <template v-slot:selection="{ item, index }">
            <v-chip :key="index" close @click:close="remove(item)" class="chip-custom">
              {{ item.desc_nivel }}
            </v-chip>
          </template>
        </AutocompleteComp>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-0">

        <AutocompleteComp v-model="id_turnos" :items="listTurno" attach chips textLabel="Turno" multiple
          item-text="desc_turno" item-value="id" hide-details 
          :rules="validationRules.validateCampo">
          <template v-slot:selection="{ item, index }">
            <v-chip :key="index" close @click:close="remove(item)" class="chip-custom">
              {{ item.desc_turno }}
            </v-chip>
          </template>
        </AutocompleteComp>
      </v-col>

      <v-col cols="12" sm="6" md="12" class="py-0">
        <!-- original -->
        <!-- <AutocompleteComp v-model="areas" :items="listAreas" attach chips textLabel="Áreas" multiple :smallChips="true" :deletableChips="true"
          item-text="area_nivel" item-value="id" hide-details :rules="validationRules.validateCampo">
          <template v-slot:selection="{ item, index }">
            <v-chip :key="index" close @click:close="remove(item)" class="chip-custom">
              {{ item.area_nivel }}
            </v-chip>
          </template>
        </AutocompleteComp> -->



        <!-- selects de new -->
        <v-autocomplete v-model="areas" :items="listAreas" attach  textLabel="Áreas" multiple dense
          item-text="area_nivel" item-value="id" hide-details :rules="validationRules.validateCampo">
          <template v-slot:selection="{ item, index }">
              <span :key="index" v-if="index === 0"  @click:close="remove(item)">{{ areas.length }} áreas seleccionadas - Revisar tabla</span>
            <!-- <span
              v-if="index === 1"
              class="grey--text text-caption"
            >
              (+{{ areas.length - 1 }} áreas)
            </span> -->
          </template>
        </v-autocomplete>
      </v-col>
      
      <v-row justify="end" class="mt-8">
        <v-col cols="auto">
          <ButtonComp @click="deleteConfirm()" normalButton textButton="Eliminar" classColor="red" />
        </v-col>

        <v-col cols="auto">
          <ButtonComp @click="saveItem()" text-button="Guardar" iconBut="fas fa-save" normalButton />
        </v-col>
      </v-row>
    </v-row>


    <v-card class="pa-4 mt-15" outlined>
      <v-card-title>
        Áreas seleccionadas
      </v-card-title>
      <v-data-table :headers="headersAreas" :items="listaDocentes" sort-by="calories" class="elevation-1" dense>
        <template v-slot:item.borrar="{ item }">
          <!-- <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon> -->
          <v-icon class="mr-2" color="red" @click="removeArea(item.id)">
            mdi-close
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <ComunDialogComp v-model="dialog_delete" Deletedialog @close-modal="dialog_delete = false"
      @delete-item="funcionConfirm('si')" @cancel-item="funcionConfirm('no')" titleWindow="Eliminar registro">
      <template v-slot:body>
        {{ desc_confirm }}

      </template>
    </ComunDialogComp>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { validationRules } from "@/helpers/validatorHelpers.js";
import { mapMutations } from "vuex";
import ComunDialogComp from "../../../components/ComponentsEst/ComunDialogComp";
import ButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";

export default {
  name: "configuraciondocente",
  components: {
    ButtonComp,
    AutocompleteComp,
    ComunDialogComp,
  },
  data: () => ({
    id_colegio: sessionStorage.id_colegio,
    id_ano_lectivo: sessionStorage.id_ano_lectivo,
    id_personal: "",
    id_persona: "",
    numdocPersona: "",
    listDocente: [],
    tipoDocente: [],
    tipo_docente: [],
    cantidadHoras: [20, 30, 40],
    cantidad_horaacademica: "",
    listNivel: [],
    nivel: [],
    id_nivel: "",
    listAreas: [],
    areas: [],
    idsPersonas: [],
    dialog_delete: false,
    desc_confirm: "",
    id_turnos: [],
    listTurno:[],
    validateFields: true,
    headersAreas: [
        {
          text: 'Áreas',
          align: 'start',
          sortable: false,
          value: 'area',
        },
        {
          text: 'Nivel',
          align: 'start',
          sortable: true,
          value: 'nivel',
        },
        {
          text: 'Eliminar',
          align: 'center',
          sortable: false,
          value: 'borrar',
        },
    ]
  }),
  mounted() {
    this.allDocentes();
    this.getTiposDocentes();
    this.GetNivel();
    this.GetAreasNivel();
    this.getTurno();
  },
  computed: {
    validationRules() {
      return validationRules;
    },
    listaDocentes: {

      get: function () {
        
        const idSet = new Set(this.areas);
        
        let filtered = this.listAreas.filter(area => idSet.has(area.id));
        let done = filtered.map(doc => {
        let [area, nivel] = doc.area_nivel.split("-")
        return {
          id: doc.id,
          area: area,
          nivel: nivel
        }
      });
        
        return done
      },
      set: function (newData) {
        return newData
      }

    },
  },
  methods: {

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    async getDocente(id_personal) {
      this.cleanFiltro();
      this.validateFields = true;

      try {
        let response = await axios.post(
          "/horario/ConfiguracionDocente/getdocentes/numdoc",
          {
            id_personales: id_personal.id,
          }
        );
        if (response.data.payload.length === 0) {
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
          return;
        } else {
          this.id_personales = response.data.payload[0].id_personales;
          this.tipo_docente = response.data.payload[0].tipo_docente;
          this.cantidad_horaacademica = response.data.payload[0].cantidad_horaacademica;
          this.id_nivel = response.data.payload[0].id_nivel;
          this.areas = response.data.payload[0].areas;
          this.id_turnos = response.data.payload[0].turno;
          this.GetAreasNivel();

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: error.response.data.message || "Error en la respuesta del servidor",
          tiempo: null,
        });
      }
    },

    async GetNivel() {
      let params = {
        id_colegio: this.id_colegio,
        id_ano_lectivo: this.id_ano_lectivo,
      };
      try {
        let response = await axios.post(`/sistema/integral/getNivelAdm/`, {
          filter: params,
        });

        if (response.data.length == 0) return;

        this.listNivel = response.data.map((nivel) => {
          return {
            desc_nivel: nivel.desc_nivel,
            id: nivel.id,
          };
        });
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: error.response.data.message || "Error en la respuesta del servidor",
          tiempo: null,
        });
        
      }
    },
    async allDocentes() {
      try {
        let response = await axios.get(
          `/horario/cargaDocente/${this.id_colegio}`
        );
        this.listDocente = response.data;
      } catch (e) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: e.response.data.message || "Error en la respuesta del servidor",
          tiempo: null,
        });
      }
    },

    async getTiposDocentes() {
      try {
        let response = await axios.get("/mantenimiento/tiposdocentes");
        if (response.data.messageT == "E" || response.data.length == 0) return;
        this.tipoDocente = response.data.map((item) => {
          return {
            id: item.id,
            desc_tipo_docente: item.desc_tipo_docente,
          };
        });
        return this.tipoDocente;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: error.response.data.message || "Error en la respuesta del servidor",
          tiempo: null,
        });
      }
    },

    async getTurno() {
      try {
        let response = await axios.get("/mantenimiento/turnos");
        this.listTurno= response.data; console.log("list", this.listTurno);
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    async GetAreasNivel() {
      let params = {
        id_colegio: this.id_colegio,
        id_ano_lectivo: this.id_ano_lectivo,
        id_adm_nivel: this.id_nivel,
      };

      try {
        let response = await axios.post(
          `administrativo/personal/nivel`,
          params
        );
        if (response.data.messageT == "E" || response.data.length == 0) return;

        // Mapear los datos para extraer desc_nivel e id
        this.listAreas = response.data.map((nivel) => {
          return {
            area_nivel: nivel.area_nivel,
            id: nivel.id,
          };
        });
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: error.response.data.message || "Error en la respuesta del servidor",
          tiempo: null,
        });
      }
    },
    //post al back

    async saveItem() {
      // Buscar el id_persona y numdocPersona basados en el id_personal
      this.listDocente.forEach((docente) => {
        if (docente.id == this.id_personal.id) {
          this.id_persona = docente.id_persona;
          this.numdocPersona = docente.numdoc_persona;
        }
      });

      // Validar que todos los campos obligatorios estén llenos
      if (!this.id_colegio) {
        this.setEnviarMens({ tipo: "E", mensaje: "El campo 'Colegio' es obligatorio.", tiempo: null });
        return;
      }
      if (!this.id_ano_lectivo) {
        this.setEnviarMens({ tipo: "E", mensaje: "El campo 'Año lectivo' es obligatorio.", tiempo: null });
        return;
      }
      if (!this.id_persona) {
        this.setEnviarMens({ tipo: "E", mensaje: "El campo 'Persona' es obligatorio.", tiempo: null });
        return;
      }
      if (!this.id_personal || !this.id_personal.id) {
        this.setEnviarMens({ tipo: "E", mensaje: "El campo 'Personal' es obligatorio.", tiempo: null });
        return;
      }
      if (!this.tipo_docente) {
        this.setEnviarMens({ tipo: "E", mensaje: "El campo 'Tipo de docente' es obligatorio.", tiempo: null });
        return;
      }
      if (!this.cantidad_horaacademica) {
        this.setEnviarMens({ tipo: "E", mensaje: "El campo 'Cantidad de horas académicas' es obligatorio.", tiempo: null });
        return;
      }
      if (!this.id_nivel || !this.id_nivel.length) {
        this.setEnviarMens({ tipo: "E", mensaje: "El campo 'Nivel' es obligatorio.", tiempo: null });
        return;
      }
      if (!this.areas || !this.areas.length) {
        this.setEnviarMens({ tipo: "E", mensaje: "El campo 'Áreas' es obligatorio.", tiempo: null });
        return;
      }

      const params = {
        id_colegio: this.id_colegio,
        id_ano_lectivo: this.id_ano_lectivo,
        id_persona: this.id_persona,
        id_personales: this.id_personal.id,
        numdoc_persona: this.numdocPersona,
        tipo_docente: this.tipo_docente,
        cantidad_horaacademica: this.cantidad_horaacademica,
        id_nivel: this.id_nivel,
        areas: this.areas,
        turno: this.id_turnos,
      };

      try {
        const response = await axios.post("horario/ConfiguracionDocente", params);
      
        if (response.data.messageT == "S") {
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        }
        this.cleanFiltro();
        this.id_personal = "";
        this.validateFields = false;

      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: error.response.data.message || "Error en la respuesta del servidor",
          tiempo: null,
        });
      }
    },


    cleanFiltro() {
      this.tipo_docente = "";
      this.cantidad_horaacademica = "";
      this.id_nivel = [];
      this.areas = [];
      this.id_turnos = [];
    },

    deleteConfirm() {
      this.desc_confirm = "¿Está seguro de eliminar este registro?";
      this.dialog_delete = true;
    },

    async funcionConfirm(resp,) {
      if (resp == "si") {
        this.deleteDocente();
      } else {
        this.dialog_delete = false;
      }
    },

    async deleteDocente() {
      if (!this.id_personales) {
        return;
      }

      try {
        let response = await axios.post("/horario/ConfiguracionDocente/deletedocente", {
          id_personales: this.id_personales
        });
     
        if (response.data.messageT == "S") {
          this.cleanFiltro();
          this.listDocente = this.listDocente.filter(docente => docente.id_personal !== this.id_personal);
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
          this.dialog_delete = false;
        } else {
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: error.response.data.message || "Error en la respuesta del servidor",
          tiempo: null,
        });
      }
    },

    removeArea(itemId) {
      this.areas = this.areas.filter(area => area !== itemId);
    },
    agregarArea(value){
      
      const areaExists = this.areas.some(area => area.id == value);
      
      if (!areaExists) {
        const selected = this.listAreas.find(item => item.id === value);
        if (selected) {
          this.areas.push(selected);
        }
      }
    },
  },
};
</script>

<style>
</style>